export default "__VITE_ASSET__671ee07a__"